import { useState, useEffect } from "react";

const useSessionState = (key, defaultValue) => {
  // Get initial state from session storage, if available
  const initialState = sessionStorage.getItem(key)
    ? JSON.parse(sessionStorage.getItem(key))
    : defaultValue;

  // State variable to hold the current value
  const [state, setState] = useState(initialState);

  // Update session storage whenever the state changes
  useEffect(() => {
    if (!state) {
      sessionStorage.removeItem(key);
      return;
    }
    sessionStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
};

export default useSessionState;
